import { render, staticRenderFns } from "./addListThumb.vue?vue&type=template&id=57a12631&ref=addItemImage&"
import script from "./addListThumb.vue?vue&type=script&lang=js&"
export * from "./addListThumb.vue?vue&type=script&lang=js&"
import style0 from "./addListThumb.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports